<template>

  <div class="container-fluid">

    <BannerComponent title="BiotXplorer" subtitle="searching biotic interactions in the literature" />

    <div class="row">
        <QueryBox @searchBiotic=searchBiotic />
    </div>

    <div class="row">
        <ResultsBox ref="resultsBox"/>
    </div>

  </div>

</template>

<script>

import BannerComponent from '@/components/BannerComponent.vue'
import QueryBox from '@/components/QueryBox.vue'
import ResultsBox from '@/components/ResultsBox.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    BannerComponent,
    QueryBox,
    ResultsBox,
  },
  data() {
        return {
            showResults: false,
        }
  },
  computed: {
        ...mapState(['user_query', 'user_selection', 'theme_color']),
  },
  methods:{
    ...mapActions(['updateTaxon1', 'updateTaxon2', 'updateInteraction']),
    searchBiotic(){
      this.$refs.resultsBox.search()
    }

  },
  watch: {

  },
  beforeMount() {
    if ('taxon1' in this.$route.query && this.$route.query.taxon1.length > 0){
      var taxon1 = this.$route.query.taxon1
      this.updateTaxon1(taxon1)
    }
    if ('taxon2' in this.$route.query && this.$route.query.taxon2.length > 0){
      var taxon2 = this.$route.query.taxon2
      this.updateTaxon2(taxon2)
    }
    if ('interaction' in this.$route.query && this.$route.query.interaction.length > 0){
      var interaction = this.$route.query.interaction
      this.updateInteraction(interaction)
    }
  }
    
}

</script>

<style scoped lang="scss">

    .container-fluid{
        padding-right: 0px;
        padding-left: 0px;
        margin-right: auto;
        margin-left: auto;
    }

    .row {
        padding: 50px;
        margin-left: 0;
        margin-right: 0;
    }

    .warning-container{
      background-color: lightgoldenrodyellow;
      padding: 10px;
      margin: 10px;
    }

</style>